// Domain types for the Safety → Hazardous Chemicals register.

export type GhsSignal = 'Danger' | 'Warning' | 'None';

export type SdsStatus = 'Attached' | 'Missing';

export interface SdsFile {
    fileName: string;
    uploadedAt: string; // ISO
    sizeLabel: string; // e.g. "2.4 MB"
    url?: string;      // S3 signed URL when available
    s3Key?: string;    // S3 object key for generating fresh signed URLs
}

export interface AuditEntry {
    id: string;
    action: string; // e.g. "SDS uploaded", "Chemical added to register"
    who: string;
    date: string; // ISO
}

export interface Chemical {
    id: string;

    name: string;
    quantity: string; // free text incl. unit, e.g. "20 L", "G-Size cylinder"
    ghsSignal: GhsSignal;
    dangerousGoods: boolean; // the "DG" tag
    unNumber: string; // e.g. "UN1789" or ''
    poisonSchedule: string; // "Poison Schedule / pH", e.g. "S7 / pH 1" or "N/A"
    storage: string; // storage requirements
    intendedUse: string;
    ppeRequired: string; // free text list, e.g. "Gloves, goggles, respirator"
    location: string;
    owner: string; // Owner / Responsible Person

    sds: SdsFile | null; // null => SDS Missing
    lastReview: string | null; // YYYY-MM-DD or ISO — used for "review due" logic
    audit: AuditEntry[];

    // Soft delete
    deleted: boolean;
    deletedAt?: string;
    deletedBy?: string;

    lastModifiedBy: string;
    lastModifiedAt: string;
}

// Configurable option lists (managed in Safety → Settings)
export interface ChemicalLists {
    ghsSignal: GhsSignal[];
    ppeOptions: string[]; // checkbox list on the Add/Edit form
    locations: string[];
}

export const REVIEW_DUE_MONTHS = 12; // reviews older than this are "Review Due"
